import { GEM_NAMES, GEM_SHAPES, GLYPHS, GUARDIAN_COLORS, PALETTE } from "@eldrun/content";
import { h } from "../kit/dom.ts";

/** Forma de cada gema (a da paleta: ▲ ● ■ ★ ◆, F60). */
export const relicShape = (color: string): string => GLYPHS[GEM_SHAPES[color as keyof typeof GEM_SHAPES] ?? "circulo"].char;

export interface RelicSlot {
  color: string;
  have: boolean;
}

/** Os cinco espaços do Relicário (doc 07, I8), na ordem das cores, com os já conquistados. */
export function relicSlots(have: (color: string) => boolean): RelicSlot[] {
  return GUARDIAN_COLORS.map(({ color }) => ({ color, have: have(color) }));
}

/** Relicário do grupo no HUD: cinco espaços, cheios quando a gema foi conquistada. */
export class RelicHud {
  readonly element: HTMLElement;
  private readonly slots: HTMLElement[];
  private key = "";

  constructor(parent: HTMLElement) {
    // Forma própria em cada espaço (doc 05: cor sempre acompanhada de símbolo).
    this.slots = GUARDIAN_COLORS.map(({ color }) => h("span", { class: "muiraquita", title: GEM_NAMES[color] }, relicShape(color)));
    this.element = h("div", { id: "relicario", "aria-label": "Relicário" }, h("span", { class: "titulo" }, "Relicário"), ...this.slots);
    parent.appendChild(this.element);
  }

  update(slots: readonly RelicSlot[]): void {
    const key = slots.map((s) => (s.have ? "1" : "0")).join("");
    if (key === this.key) return;
    this.key = key;
    // Malha neon (F60): as gemas são brancas e se reconhecem pela forma (as cores delas colidiam com as
    // dos jogadores e do chefe).
    const neutral = PALETTE.neutro.hex;
    slots.forEach((s, i) => {
      const el = this.slots[i];
      if (!el) return;
      el.classList.toggle("cheio", s.have);
      el.style.background = s.have ? neutral : "";
      el.style.color = s.have ? "var(--fundo)" : neutral;
      el.setAttribute("aria-label", `${GEM_NAMES[s.color as keyof typeof GEM_NAMES] ?? s.color}${s.have ? " no Relicário" : " faltando"}`);
    });
  }

  /** Quantos estão no Relicário (testes e2e). */
  get count(): number {
    return this.key.slice(0, GUARDIAN_COLORS.length).split("").filter((c) => c === "1").length;
  }
}
